module.exports = __webpack_public_path__ + "static/media/moon-logo.a09fee9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moon-logo.png
// module id = 28
// module chunks = 0